<template>
    <div class="bg-main">
        <TopBar :isShowToggle="true"></TopBar>
        <div class="container">
            <b-card header="Personal Details" class="text-left custom-card">
                <b-card-text class="custom-text-form">
                    <div class="row">
                        <div class="col-md-6">
                            <div class="row">
                                <label class="col-12">Card Number</label>
                                <div class="col-12">
                                    <input
                                        @input="inputCardNo()"
                                        maxlength="16"
                                        type="text"
                                        class="form-control"
                                        v-model="form.cardNO.value"
                                    />
                                </div>
                            </div>
                        </div>
                        <div class="col-md-6">
                            <div class="row">
                                <label class="col-12"
                                    >Full name as per NRIC / Passport</label
                                >
                                <div class="col-12">
                                    <input
                                        maxlength="50"
                                        type="text"
                                        class="form-control"
                                        @input="inputName()"
                                        v-model="form.nameidCard.value"
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-6">
                            <div class="row">
                                <label class="col-12"
                                    >NRIC / Passport Number</label
                                >
                                <div class="col-12">
                                    <input
                                        @input="inputNewCardNo()"
                                        maxlength="12"
                                        type="text"
                                        class="form-control"
                                        form.
                                        v-model="form.idCard.value"
                                    />
                                </div>
                            </div>
                        </div>
                        <div class="col-md-6">
                            <div class="row">
                                <label class="col-12">Email</label>
                                <div class="col-12">
                                    <input
                                        type="text"
                                        class="form-control"
                                        @input="inputEmail()"
                                        v-model="form.email.value"
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-6">
                            <div class="row">
                                <label class="col-12"
                                    >Mobile Phone Number</label
                                >
                                <div class="col-12">
                                    <b-input-group>
                                        <template v-slot:prepend>
                                            <b-dropdown
                                                :text="form.prefixPhone.value"
                                                class="custom-input-dropdown"
                                                v-model="form.prefixPhone.value"
                                            >
                                                <b-dropdown-item
                                                    v-for="p in prefixPhone"
                                                    v-bind:key="p"
                                                    @click="
                                                        form.prefixPhone.value = p
                                                    "
                                                    >{{ p }}</b-dropdown-item
                                                >
                                            </b-dropdown>
                                        </template>
                                        <input
                                            maxlength="10"
                                            type="text"
                                            class="form-control"
                                            placeholder="1123456789"
                                            @input="inputMobileNo()"
                                            v-model="form.phone.value"
                                        />
                                    </b-input-group>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row section-policy">
                        <div class="col-12">
                            <b-form-checkbox
                                v-model="form.acceptCondition.value"
                                name="checkbox-1"
                                value="true"
                                unchecked-value="false"
                            >
                                <span
                                    >By ticking this box, I hereby acknowledge
                                    that I have read and understood the Terms
                                    and Conditions of the BHPetrol eCard Loyalty
                                    Programme and Boustead Petroleum Marketing
                                    Sdn. Bhd’s("BHPetrol")
                                    <a
                                        class="custom-text-color"
                                        target="_blank"
                                        href=" http://www.bhpetrol.com.my/disclaimer/privacy-policy"
                                        ><u
                                            >Personal Data Protection Notice
                                            ("Privacy Notice")</u
                                        ></a
                                    >
                                    and agree to be bound by the Terms and
                                    Conditions and for my personal data to be
                                    processed in the manner as set forth in the
                                    Privacy Notice.</span
                                >
                            </b-form-checkbox>
                        </div>
                    </div>
                    <div class="row mt-3 custom-btn-color">
                        <div class="col-12 text-center">
                            <button
                                @click="clickReset()"
                                class="theme-btn mr-3"
                            >
                                Reset
                            </button>
                            <button
                                class="theme-btn mr-3"
                                @click="clickSubmit()"
                            >
                                Submit
                            </button>
                            <button
                                class="theme-btn mr-3"
                                @click="goto('home')"
                            >
                                Main Page
                            </button>
                        </div>
                    </div>
                </b-card-text>
            </b-card>
        </div>
        <BottomBar></BottomBar>
        <ModalMaster :controller="modalController"></ModalMaster>
    </div>
</template>

<script>
// @ is an alias to /src
import Vue from "vue";
import Util from "@/helper/Utility.js";
import Account from "@/helper/AccountHelper.js";
import LocaleMixin from "@/mixin/LocaleMixin.js";
import ErrorApiMixin from "@/mixin/ErrorApiMixin.js";
import ModalMaster from "@/components/Modal/Component/ModalMaster.vue";
import ModalFactory from "@/components/Modal/ModalFactory.js";
// load new component
import TopBar from "@/components/Layout/TopBar/TopBar.vue";
import BottomBar from "@/components/Layout/BottomBar/BottomBar.vue";

// load service
import BzbsRegistration from "@/module/Registration/service/BzbsRegistration.js";
import { RegistrationModelBulider } from "@/module/Registration/model/RegistrationModel.js";

export default {
    name: "registration",
    components: {
        ModalMaster,
        TopBar,
        BottomBar
    },
    mixins: [LocaleMixin, ErrorApiMixin],
    beforeRouteLeave(to, from, next) {
        // validate enter some text at input
        let checkInput = this.checkInput();
        if (checkInput) {
            this.confirmModal
                .clearText()
                .setMsg(
                    "You have not completed the process. Are you sure you want to leave page?"
                )
                .setBtnOk("Back")
                .setBtnCancel("Leave")
                .setTag("test-confirm")
                .show();
            this.confirmModal.onClickCancel(() => next());
        } else next();
    },
    data: function() {
        return {
            isFirstSaveForm: true,
            valid: false,
            prefixPhone: ["+60", "+65", "+66"],
            form: {
                cardNO: { value: null, errMsg: null },
                nameidCard: { value: null, errMsg: null },
                idCard: { value: null, errMsg: null },
                email: { value: null, errMsg: null },
                prefixPhone: { value: null, errMsg: null },
                phone: { value: null, errMsg: null },
                acceptCondition: { value: null, errMsg: null }
            },
            // all new modal
            modalController: null,
            alertModal: null,
            loadingModal: null,
            confirmModal: null
        };
    },
    created: function() {
        this.form.prefixPhone.value = this.prefixPhone[0];
        Account.loginStatus().then(status => {
            this.isLogin = status;
            if (status) {
                this.profile = Account.getCacheProfile();
            }
        });
        // modal setup
        let modalFactory = new ModalFactory();
        this.modalController = modalFactory.getModalController();
        this.alertModal = modalFactory.getAlertModal();
        this.confirmModal = modalFactory.getConfirmModal();
        this.loadingModal = modalFactory.getLoadingModal();
    },
    methods: {
        checkInput: function() {
            let isInput = false;
            let form = this.form;
            try {
                if (form.cardNO.value) throw false;
                if (form.nameidCard.value) throw false;
                if (form.email.value) throw false;
                if (form.phone.value) throw false;
                if (form.acceptCondition.value) throw false;
            } catch (ex) {
                isInput = true;
            }
            return isInput;
        },
        goto: function(location) {
            switch (location) {
                case "home":
                    this.$router.push("/");
                    break;
                default:
                    break;
            }
        },
        clickReset: function() {
            this.isFirstSaveForm = true;
            this.form = {
                cardNO: { value: null, errMsg: null },
                nameidCard: { value: null, errMsg: null },
                idCard: { value: null, errMsg: null },
                email: { value: null, errMsg: null },
                prefixPhone: { value: this.prefixPhone[0], errMsg: null },
                phone: { value: null, errMsg: null },
                acceptCondition: { value: null, errMsg: null }
            };
        },
        clickSubmit: async function() {
            this.isFirstSaveForm = false;
            this.validateForm();
            if (!this.valid) return false;
            let form = this.form;
            let modelBuilder = new RegistrationModelBulider();
            modelBuilder
                .setCardNo(form.cardNO.value)
                .setPersonalId(form.idCard.value)
                .setFullName(form.nameidCard.value)
                .setMobile(form.prefixPhone.value + form.phone.value)
                .setEmail(form.email.value);
            let params = modelBuilder.create().getParams();
            this.loadingModal.show();
            try {
                let res = await BzbsRegistration.newRegistration(params);
                if (res) {
                    this.clickReset();
                    this.alertModal
                        .clearText()
                        .setTitle("Congratulations")
                        .setMsg("Your registration is successful")
                        .setBtnOk("Main Page")
                        .setTag("congratulation-register")
                        .show();
                    this.alertModal.onClickOk(() => {
                        this.$router.push("/");
                    });
                } else {
                    throw res;
                }
            } catch (ex) {
                console.log("ex", ex);
                this.errorHandle(ex);
            }

            this.loadingModal.hide();
        },
        inputName: function() {
            let value = this.form.nameidCard.value;
            value = value.replace(/[0-9\u0E00-\u0E7F]+/g, "");
            this.form.nameidCard.value = value;
        },
        inputEmail: function() {
            // this.validateForm();
        },
        inputMobileNo: function() {
            this.form.phone.value = this.replaceCharacter(
                this.form.phone.value
            );
            // this.validateForm();
        },
        inputCardNo: function() {
            this.form.cardNO.value = this.replaceCharacter(
                this.form.cardNO.value
            );
            // this.validateForm();
        },
        inputNewCardNo: function() {
            let value = this.form.idCard.value;
            // remove special character
            value = value.replace(/[^\w\s]/gi, "");
            this.form.idCard.value = value;
            // this.validateForm();
        },
        validateForm: function() {
            this.valid = false;
            if (this.isFirstSaveForm) return false;
            //#region validate card no..
            this.form.cardNO.errMsg = null;
            if (Util.isEmptyStr(this.form.cardNO.value))
                this.form.cardNO.errMsg = "Please enter Card Number";
            else if (this.form.cardNO.value.length != 16)
                this.form.cardNO.errMsg =
                    "Please enter 16-digits of physical card number.";
            //#endregion

            //#region validate full name identity card no.
            this.form.nameidCard.errMsg = null;
            if (Util.isEmptyStr(this.form.nameidCard.value))
                this.form.nameidCard.errMsg =
                    "Please enter Full Name as per NRIC / Passport";
            //#endregion

            //#region validate identity card no.
            this.form.idCard.errMsg = null;
            if (Util.isEmptyStr(this.form.idCard.value))
                this.form.idCard.errMsg = "Please enter NRIC / Passport Number";
            else {
                // check case if only number is NRIC ID otherwise passportId
                let isPassportId = isNaN(this.form.idCard.value);
                if (isPassportId) {
                    if (
                        this.form.idCard.value.length < 8 ||
                        this.form.idCard.value.length > 9
                    )
                        this.form.idCard.errMsg =
                            "Invalid Passport number. Please re-enter a correct Passport number.";
                } else {
                    if (this.form.idCard.value.length != 12)
                        this.form.idCard.errMsg =
                            "Invalid NRIC number. Please re-enter a correct NRIC number.";
                }
            }
            //#endregion

            //#region validate email
            this.form.email.errMsg = null;
            if (Util.isEmptyStr(this.form.email.value)) {
                this.form.email.errMsg = "Please enter Email";
            } else if (!Vue.validator.validateEmail(this.form.email.value)) {
                this.form.email.errMsg =
                    "Incorrect email entered. Please try again.";
            }
            //#endregion

            //#region validate mobile no
            this.form.phone.errMsg = null;

            if (Util.isEmptyStr(this.form.phone.value)) {
                this.form.phone.errMsg = "Please enter your mobile number.";
            } else if (
                this.form.phone.value.length < 9 ||
                this.form.phone.value.length > 10
            ) {
                this.form.phone.errMsg =
                    "Invalid mobile phone number entered. Please try again.";
            }
            //#endregion

            //#region validate acceppt condition
            this.form.acceptCondition.errMsg = null;
            if (this.form.acceptCondition.value != "true") {
                this.form.acceptCondition.errMsg =
                    "Please accept Terms and Conditions";
            }
            //#endregion
            let error = [];
            Object.keys(this.form).forEach(v => {
                let err = this.form[v].errMsg;
                if (err) error.push(err);
            });
            if (error.length > 0) {
                this.alertModal
                    .clearText()
                    .setMsg(`Error<br/>${error[0]}`)
                    .setBtnOk("Main page")
                    .setIsShowSmallClose(true)
                    .setTag("error-info")
                    .show();
                this.alertModal.onClickOk(() => {
                    this.$router.push("/");
                });
            }
            this.valid = error == 0;
        },
        errorHandle: function(exception) {
            let body = ``;
            if (exception.response) {
                let msg = exception.response.data.error;
                body += `<div>Error ${msg.code}</div>`;
                // console.log("msg", msg);
                // switch (msg.message) {
                //     case "1|Invalid Card Entered":
                //         body += `<div>Invalid Card Entered</div>`;
                //         break;
                //     case "3|Card Was Registered":
                //         body += `<div>Card was registered</div>`;
                //         break;
                //     default:
                //         break;
                // }
                body += `<div>Please contact BHPetrol Customer Service Centre at 03- 7719 9499 for further assistance.</div>`;
            } else {
                body = `cannot connect to network`;
            }
            this.alertModal
                .clearText()
                .setTitle(`Your registration is unsuccessful.`)
                .setMsg(body)
                .setBtnOk("Main page")
                .setIsShowSmallClose(true)
                .setTag("error-info")
                .show();
            this.alertModal.onClickOk(() => {
                this.$router.push("/");
            });
        },
        replaceCharacter: function(txt) {
            txt = txt.replace(Vue.RegExp.emoji, "");
            txt = txt.replace(Vue.RegExp.notNumber, "");
            return txt;
        }
    }
};
</script>
<style lang="scss" scoped>
@import "Registration.scss";
</style>
